module.exports = "/assets/freebies/kropla.png?rEbXFTI";